import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import Dashboard from './containers/dashboard/dashboard';
import Analisis from './containers/analisis/analisis';
import Simulador from './containers/simulador/simulador';
// import SimuladorReactivo from './containers/simulador/simulacionReactiva';
import SimuladorStep2 from './containers/simulador/simulador-s02';
import LoginForm from './containers/login/login';
import PageNotFound from './components/pageNotFound/PageNotFound';
// import ForgotPassword from './containers/login/forgotPassword';
import Map from './containers/map/map';
import Admin from './containers/admin/admin';


class App extends Component {
  render() {
      if (this.props.user && this.props.user.token){
          return (
              <Router>
                  <div>
                      <Route exact path="/analisis" component={Analisis}/>
                      <Route exact path="/mapa" component={Map}/>
                      <Route exact path="/analisis/:type/:id" component={Analisis}/>
                      <Route exact path="/analisis/:type/:action/:id" component={Analisis}/>
                      <Route exact path="/simulador" component={Simulador}/>
                      <Route exact path="/simulador/:cluster_id" component={Simulador}/>
                      <Route exact path="/simulador/:cluster_id/:cluster_name" component={Simulador}/>
                      <Route exact path="/simulador-02" component={SimuladorStep2}/>
                      <Route exact path="/admin" component={Admin}/>
                      <Route exact path="/" component={Dashboard}/>
                  </div>
              </Router>
          );
      }
      return (
          <Router>
              <Switch>
                  <Route exact path="/" component={LoginForm}/>
                  {/*<Route path="/forgot-password" component={ForgotPassword}/>*/}
                  <Route path='*' component={PageNotFound} />
              </Switch>
          </Router>
      );
  }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

export default connect(mapStateToProps)(App);





// WEBPACK FOOTER //
// ./src/App.js